// import React, { useState } from "react";
// import { Form, Row, Col, Dropdown } from "react-bootstrap";
// import closeBtn from "./../../../assets/images/Profile_Img/ProfileCloseBtn.svg";
// import "../profile_styles/ProfileScreenStyle.css";
// import { useSelector, useDispatch } from "react-redux";
// import { RootState } from "../../../store/store";
// // import { updateProfile } from "./../../login/data/redux/LoginReducer";
// import { useAlert } from "../../../components/AlertContextComponent";
// import Loader, { LocalStorage } from "./../../../utils/Utils";
// import { useApi } from "../../../service/ApiContext";
// import { ProfileRequest } from "../data/request/ProfileRequest";
// import { ProfileSaveResponse } from "../data/response/ProfileResponse";
// import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
// import ProfileClient from "../data/api/LoginClient";
// import { updateProfile } from "../../dashboard/data/redux/LoginReducer";
// interface ProfileEditProps {
//   onCancel: () => void;
//   onSave: () => void;
//   isFormDisabled: boolean;
// }

// const ProfileEdit: React.FC<ProfileEditProps> = ({
//   onCancel,
//   onSave,
//   isFormDisabled,
// }) => {
//   const dispatch = useDispatch();
//   const { showAlert } = useAlert();
//   const api = useApi();

//   // Select the data from the Redux store
//   const userData = useSelector((state: RootState) => state.profile.profileKeys);

//   // Local state to handle form inputs
//   const [formData, setFormData] = useState(userData);

//   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleSave = async () => {
//     Loader.showLoading("Loading...");

//     api.setAuthToken(LocalStorage.getLocalData("access_token"));

//     const params: ProfileRequest = {
//       course: formData.course,
//       contact_email: formData.contact_email,
//       admission_year: formData.admission_year,
//       grade: formData.grade,
//       roll_number: formData.roll_number,
//       first_name: formData.first_name,
//       last_name: formData.last_name,
//       institute_name: formData.institute_name,
//       education: formData.education,
//     };

//     try {
//       const response = await api.post<ProfileSaveResponse>(
//         ProfileClient.profileUrl,
//         params,
//       );
//       dispatch(updateProfile(formData));
//       showAlert({
//         show: true,
//         title: "Success",
//         message: response.data.detail,
//         button1Text: "OK",
//         alertType: "success",
//         onlyNeedOneButton: true,
//         btn1onPressed: onSave,
//       });
//     } catch (error) {
//       // showAlert({
//       //   show: true,
//       //   title: "Error",
//       //   message: "Failed to save profile data. Please try again.",
//       //   button1Text: "OK",
//       //   alertType: "error",
//       //   onlyNeedOneButton: true,
//       // });
//     } finally {
//       Loader.dismissLoading();
//     }
//   };
//   const userType = LocalStorage.getLocalData("userType");

//   const [selectedValue, setSelectedValue] = useState(
//     formData.no_of_employees || "",
//   );

//   const handleSelect = (value: string | null) => {
//     setSelectedValue(value || "");
//     setFormData({ ...formData, no_of_employees: value || "" });
//   };
//   return (
//     <div>
//       <div className="v2-profile-container">
//         <div className="v2-profile-header">
//           <p className="v2-profile-title">My Account</p>
//           <div className="v2-profile-divider"></div>
//         </div>

//         {/* Top Card */}
//         <div className="v2-profile-top-card">
//           <div className="v2-profile-user-section">
//             <div className="v2-profile-avatar">
//               {`${formData.first_name?.[0] || ""}${formData.last_name?.[0] || ""}`}
//             </div>

//             <div className="v2-profile-user-details">
//               <p className="v2-profile-name">
//                 {formData.first_name} {formData.last_name}
//               </p>

//               <p className="v2-profile-email">{formData.contact_email}</p>
//             </div>
//           </div>

//           <img
//             src={closeBtn}
//             alt="close"
//             className="closeBtn"
//             onClick={onCancel}
//           />
//         </div>
//       </div>
//       <div className="v2-profile-info-card">
//         <p className="v2-profile-section-title">Academic Information</p>

//         <div className="v2-profile-grid">
//           <div className="v2-profile-field">
//             <span className="v2-profile-field-label">Student Roll No:</span>

//             <Form.Control
//               className="v2-profile-input"
//               type="text"
//               name="roll_number"
//               value={formData.roll_number || ""}
//               onChange={handleInputChange}
//               disabled={isFormDisabled}
//             />
//           </div>

//           <div className="v2-profile-field">
//             <span className="v2-profile-field-label">Admission Year:</span>

//             <Form.Control
//               className="v2-profile-input"
//               type="text"
//               name="admission_year"
//               value={formData.admission_year || ""}
//               onChange={handleInputChange}
//               disabled={isFormDisabled}
//             />
//           </div>

//           <div className="v2-profile-field">
//             <span className="v2-profile-field-label">
//               {userType === "CANDIDATE" ? "Course:" : "Grade:"}
//             </span>

//             <Form.Control
//               className="v2-profile-input"
//               type="text"
//               name={userType === "CANDIDATE" ? "course" : "grade"}
//               value={
//                 userType === "CANDIDATE"
//                   ? formData.course || ""
//                   : formData.grade || ""
//               }
//               onChange={handleInputChange}
//               disabled={isFormDisabled}
//             />
//           </div>
//         </div>

//         <div className="v2-profile-grid-bottom">
//           <div className="v2-profile-field">
//             <span className="v2-profile-field-label">Qualification:</span>

//             <Form.Control
//               className="v2-profile-input"
//               type="text"
//               name="education"
//               value={formData.education || ""}
//               onChange={handleInputChange}
//               disabled={isFormDisabled}
//             />
//           </div>

//           <div className="v2-profile-field">
//             <span className="v2-profile-field-label">Institute:</span>

//             <Form.Control
//               className="v2-profile-input"
//               type="text"
//               name="institute_name"
//               value={formData.institute_name || ""}
//               onChange={handleInputChange}
//               disabled={isFormDisabled}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfileEdit;

import React, { useState } from "react";
import { Form } from "react-bootstrap";
import "../profile_styles/ProfileScreenStyle.css";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../store/store";
import { useAlert } from "../../../components/AlertContextComponent";
import Loader, { LocalStorage } from "./../../../utils/Utils";
import { useApi } from "../../../service/ApiContext";
import { ProfileRequest } from "../data/request/ProfileRequest";
import { ProfileSaveResponse } from "../data/response/ProfileResponse";
import ProfileClient from "../data/api/LoginClient";
import { updateProfile } from "../../dashboard/data/redux/LoginReducer";
import editButton from "./../../../assets/images/editButton.svg";

interface ProfileEditProps {
  onCancel: () => void;
  onSave: () => void;
  isFormDisabled: boolean;
}

const ProfileEdit: React.FC<ProfileEditProps> = ({
  onCancel,
  onSave,
  isFormDisabled,
}) => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const api = useApi();

  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const [formData, setFormData] = useState(userData);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    Loader.showLoading("Loading...");

    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    const params: ProfileRequest = {
      course: formData.course,
      contact_email: formData.contact_email,
      admission_year: formData.admission_year,
      grade: formData.grade,
      roll_number: formData.roll_number,
      first_name: formData.first_name,
      last_name: formData.last_name,
      institute_name: formData.institute_name,
      education: formData.education,
    };

    try {
      const response = await api.post<ProfileSaveResponse>(
        ProfileClient.profileUrl,
        params,
      );
      dispatch(updateProfile(formData));
      showAlert({
        show: true,
        title: "Success",
        message: response.data.detail,
        button1Text: "OK",
        alertType: "success",
        onlyNeedOneButton: true,
        btn1onPressed: onSave,
      });
    } catch (error) {
      showAlert({
        show: true,
        title: "Error",
        message: "Failed to save profile data. Please try again.",
        button1Text: "OK",
        alertType: "error",
        onlyNeedOneButton: true,
      });
    } finally {
      Loader.dismissLoading();
    }
  };

  const userType = LocalStorage.getLocalData("userType");

  const editFields = [
    {
      label: "Student Roll No:",
      name: "roll_number",
      value: formData.roll_number,
    },
    {
      label: "Admission Year:",
      name: "admission_year",
      value: formData.admission_year,
    },
    {
      label: userType === "CANDIDATE" ? "Course:" : "Grade:",
      name: userType === "CANDIDATE" ? "course" : "grade",
      value: userType === "CANDIDATE" ? formData.course : formData.grade,
    },
    {
      label: "Qualification:",
      name: "education",
      value: formData.education,
    },
    {
      label: "Institute:",
      name: "institute_name",
      value: formData.institute_name,
    },
  ].filter(
    (field) =>
      field.value !== null &&
      field.value !== undefined &&
      String(field.value).trim() !== "",
  );

  return (
    <div className="v2-profile-container">
      <div className="v2-profile-header">
        <p className="v2-profile-title">My Account</p>
        <div className="v2-profile-divider"></div>
      </div>
      <div style={{ padding: "20px", height: "88vh" }}>
        {/* TOP CARD - EDIT MODE */}
        <div className="v2-profile-top-card">
          <div className="v2-profile-user-section">
            <div className="v2-profile-avatar">
              {`${formData.first_name?.[0] || ""}${
                formData.last_name?.[0] || ""
              }`}
            </div>

            <div className="v2-profile-user-details">
              <div className="v2-profile-name-edit">
                <Form.Control
                  className="v2-profile-name-input-full"
                  type="text"
                  value={`${formData.first_name || ""} ${formData.last_name || ""}`.trim()}
                  onChange={(e) => {
                    const value = e.target.value;
                    const [firstName, ...lastName] = value.split(" ");

                    setFormData((prev) => ({
                      ...prev,
                      first_name: firstName,
                      last_name: lastName.join(" "),
                    }));
                  }}
                  disabled={isFormDisabled}
                  placeholder="Full Name"
                />
              </div>
              <p className="v2-profile-email">{formData.contact_email}</p>
            </div>
          </div>

          <div className="v2-profile-edit-actions">
            <button className="v2-profile-cancel-btn" onClick={onCancel}>
              Cancel
            </button>
            <button className="v2-profile-save-btn" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>

        {/* ACADEMIC CARD - EDIT MODE */}
        <div className="v2-profile-info-card">
          <div className="v2-profile-section-header">
            <p className="v2-profile-section-title">Academic Information</p>
            {/* <img
            src={editButton}
            alt="edit"
            className="v2-profile-edit-icon"
            onClick={onCancel}
          /> */}
          </div>

          {/* <div className="v2-profile-grid">
          <div className="v2-profile-field">
            <span className="v2-profile-field-label">Student Roll No:</span>
            <Form.Control
              className="v2-profile-field-input"
              type="text"
              name="roll_number"
              value={formData.roll_number || ""}
              onChange={handleInputChange}
              disabled={isFormDisabled}
            />
          </div>

          <div className="v2-profile-field">
            <span className="v2-profile-field-label">Admission Year:</span>
            <Form.Control
              className="v2-profile-field-input"
              type="text"
              name="admission_year"
              value={formData.admission_year || ""}
              onChange={handleInputChange}
              disabled={isFormDisabled}
            />
          </div>

          <div className="v2-profile-field">
            <span className="v2-profile-field-label">
              {userType === "CANDIDATE" ? "Course:" : "Grade:"}
            </span>
            <Form.Control
              className="v2-profile-field-input"
              type="text"
              name="course"
              value={
                userType === "CANDIDATE"
                  ? formData.course || ""
                  : formData.grade || ""
              }
              onChange={handleInputChange}
              disabled={isFormDisabled}
            />
          </div>
        </div>

        <div className="v2-profile-grid-bottom">
          <div className="v2-profile-field">
            <span className="v2-profile-field-label">Qualification:</span>
            <Form.Control
              className="v2-profile-field-input"
              type="text"
              name="education"
              value={formData.education || ""}
              onChange={handleInputChange}
              disabled={isFormDisabled}
            />
          </div>

          <div className="v2-profile-field">
            <span className="v2-profile-field-label">Institute:</span>
            <Form.Control
              className="v2-profile-field-input"
              type="text"
              name="institute_name"
              value={formData.institute_name || ""}
              onChange={handleInputChange}
              disabled={isFormDisabled}
            />
          </div>
        </div> */}
          <div className="v2-profile-grid">
            {editFields.map((field) => (
              <div key={field.name} className="v2-profile-field">
                <span className="v2-profile-field-label">{field.label}</span>

                <Form.Control
                  className="v2-profile-field-input"
                  type="text"
                  name={field.name}
                  value={field.value || ""}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileEdit;
